import React from "react";
import styles from "./style.module.scss";
import Checkbox from "../../../../components/Checkbox/Index";
import Row from "./row";
import SkeletonRow from "../../../../components/skeleton-loader/table/row";
import useTemplateStore from "../../../../stores/templates";

const Table = ({ loading, data, fetchData }) => {
  const searchFilters = useTemplateStore((state) => state.searchFilters);
  const setSearchFilters = useTemplateStore((state) => state.setSearchFilters);
  const onSortClick = (type) => {
    let newSortOrder = "asc";
    if (searchFilters.sortBy === type) {
      // Toggle if clicking the same column
      newSortOrder = searchFilters.sortOrder === "asc" ? "desc" : "asc";
    }
    setSearchFilters({
      ...searchFilters,
      sortOrder: newSortOrder,
      sortBy: type,
    });
  };

  return (
    <table className={styles.table}>
      <thead className={styles.tableHead}>
        <tr className={styles.theadRow}>
        <th
            className={`${styles.th} ${styles.w40px}`}
            onClick={() => onSortClick("id")}
          >
            <div className={styles.flex}>
              <span>ID</span>
              {searchFilters?.sortBy == "id" && (
                <span
                  className={`${searchFilters?.sortBy == "id" && searchFilters?.sortOrder == "asc" ? styles.asc : styles.desc}`}
                >
                  ↑
                </span>
              )}
            </div>
          </th>

          <th
            className={`${styles.th} ${styles.w140px}`}
            onClick={() => onSortClick("name")}
          >
            <div className={styles.flex}>
              <span>Name</span>
              {searchFilters?.sortBy == "name" && (
                <span
                  className={`${searchFilters?.sortBy == "name" && searchFilters?.sortOrder == "asc" ? styles.asc : styles.desc}`}
                >
                  ↑
                </span>
              )}
            </div>
          </th>
          <th className={`${styles.th} ${styles.w140px}`}>
            <div className={styles.flex}>
              <span>Owned By</span>
            </div>
          </th>

          <th className={`${styles.th} ${styles.w40px}`}></th>
        </tr>
      </thead>

      <tbody className={styles.tableBody}>
        {loading ? (
          Array.from({ length: 8 }).map((_, index) => (
            <SkeletonRow key={`skeleton-${index}`} columnLength={4} />
          ))
        ) : (
          (data || []).map((item, index) => (
            <Row key={index} data={item} fetchData={fetchData} />
          ))
        )}
      </tbody>
    </table>
  );
};

export default Table;
